/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ViewAppliedResponse {
    getFixupPrototypeFunction() { return ViewAppliedResponse.fixupPrototype; }

    static newInstance(model: Partial<ViewAppliedResponse>): ViewAppliedResponse {
        let obj = Object.assign(new ViewAppliedResponse(), model);
        ViewAppliedResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ViewAppliedResponse>): ViewAppliedResponse {
        if (!model) return null;
        return ViewAppliedResponse.newInstance(<ViewAppliedResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ViewAppliedResponse) {
        if (!obj) return;

        models.ViewAppliedResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ViewAppliedResponse): boolean {
        Object.setPrototypeOf(obj, ViewAppliedResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.total_count === undefined) {
            this.total_count = 0;
        }
        if (this.page_count === undefined) {
            this.page_count = 0;
        }
        if (this.applied_records) {
            models.ViewAppliedResponseItem.fixupPrototype(this.applied_records);
        }
    }

    /**
     * total records count
     */
    total_count: number;

    /**
     * Count of number of pages
     */
    page_count: number;

    /**
     * view applied response data
     */
    applied_records: models.ViewAppliedResponseItem;

}
